import { apiClient } from './api'
import type { ApiResponse } from '@/types/api'
import type {
  EnrollmentProgress,
  LessonProgress,
  UpdateProgressRequest,
  QuizAttempt,
} from '@/types/enrollment'

export interface ProgressSummary {
  percentage: number
  completed: number
  total: number
}

export const progressService = {
  startLesson: async (
    enrollmentId: string,
    lessonId: string
  ): Promise<ApiResponse<EnrollmentProgress>> => {
    return apiClient.post(`/progress/lesson/start`, {
      enrollmentId,
      lessonId,
    })
  },

  completeLesson: async (
    enrollmentId: string,
    lessonId: string,
    data: Omit<UpdateProgressRequest, 'lessonId'>
  ): Promise<ApiResponse<EnrollmentProgress>> => {
    return apiClient.post(`/progress/lesson/complete`, {
      enrollmentId,
      lessonId,
      ...data,
    })
  },

  getProgress: async (enrollmentId: string): Promise<ApiResponse<EnrollmentProgress>> => {
    return apiClient.get(`/progress/enrollment/${enrollmentId}`)
  },

  getByEnrollment: async (enrollmentId: string): Promise<ApiResponse<LessonProgress[]>> => {
    return apiClient.get<LessonProgress[]>(`/progress/enrollment/${enrollmentId}`)
  },

  markLessonComplete: async (lessonId: string, enrollmentId: string): Promise<ApiResponse<void>> => {
    return apiClient.post<void>('/progress/lesson/complete', {
      lessonId,
      enrollmentId,
      completed: true,
    })
  },

  getOverallProgress: async (enrollmentId: string): Promise<ApiResponse<ProgressSummary>> => {
    return apiClient.get<ProgressSummary>(`/enrollments/${enrollmentId}/progress/summary`)
  },

  submitQuizAttempt: async (
    quizId: string,
    answers: Array<{ questionId: string; answer: string | string[] }>
  ): Promise<ApiResponse<QuizAttempt>> => {
    return apiClient.post(`/quiz-attempts/${quizId}/submit`, { answers })
  },
}
